import { render } from "./SponsoredPsychics.vue?vue&type=template&id=e3ab89d4&scoped=true"
import script from "./SponsoredPsychics.vue?vue&type=script&lang=js"
export * from "./SponsoredPsychics.vue?vue&type=script&lang=js"

import "./SponsoredPsychics.vue?vue&type=style&index=0&id=e3ab89d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ab89d4"]])

export default __exports__